import React from 'react';
import { Provider } from 'react-redux'
import { ThemeProvider } from 'glamorous';
import jsCookie from 'js-cookie';

import Loader from './components/ui/Loader';
import theme from './styles/theme';
import AppView from './views/AppView';

import boot from './boot';
import config from './config';
import store from './store';

const sessionId = jsCookie.get('sessionId');
const surveyCompleted = jsCookie.get('surveyCompleted') ? JSON.parse(jsCookie.get('surveyCompleted')) : false;


const FADE_OUT_DURATION_MS = 200;

class App extends React.Component {
  state = {
    isReady: false,
    isFadedOut: false,
    theme,
  };

  componentDidMount() {
    const handleFailure = (error) => {
      this.handleBoot();
      console.error(`App booted with error \`${error}\``);
    };

    boot({ store }).then(this.handleBoot).catch(handleFailure);
  }

  setIsReady = isReady => this.setState({ isReady });

  setTheme = theme => this.setState({ theme });

  handleBoot = () => {
    this.setIsReady(true);

    setTimeout(() => {
      this.setState({ isFadedOut: true });
    }, FADE_OUT_DURATION_MS);
  };

  handleChangeTheme = (theme) => {
    this.setTheme({
      ...this.state.theme,
      ...theme,
    });
  };

  render() {
    const {
      isReady,
      isFadedOut,
      theme,
    } = this.state;

    return (
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <div className="flex-col-1">
            <AppView
              onChangeTheme={this.handleChangeTheme}
              cookieSessionId={sessionId}
              features={config.features}
              surveyCompleted={surveyCompleted}
            />
            {!isFadedOut && (
              <Loader
                fadingOut={isReady}
                fadingOutDuration={FADE_OUT_DURATION_MS}
              />
            )}
          </div>
        </Provider>
      </ThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js